import { UI_TRANSLATIONS } from './translations';

// Helper functions
function getUITranslation(key, lang = 'en') {
    return UI_TRANSLATIONS[lang]?.[key] || UI_TRANSLATIONS['en'][key] || key;
}

function getEnumTranslation(enumObject, lang = 'en') {
    return enumObject[lang] || enumObject['en'] || Object.values(enumObject)[0];
}

function getRecipeTypeIcon(recipeType) {
    // Import here to avoid circular dependency
    const { RECIPE_TYPES } = require('./translations');
    
    if (recipeType === RECIPE_TYPES.VEGETARIAN) {
        return '🌱';
    } else if (recipeType === RECIPE_TYPES.MEAT) {
        return '🥩';
    }
    return ''; // No icon for unknown types
}

function formatDate(dateString, lang = 'en') {
    const date = new Date(dateString);
    const day = date.getDate();
    const monthIndex = date.getMonth();
    const year = date.getFullYear();
    
    const monthName = UI_TRANSLATIONS[lang]?.months?.[monthIndex] || UI_TRANSLATIONS['en'].months[monthIndex];
    
    if (lang === 'ua' || lang === 'ru') {
        return `${day} ${monthName} ${year}`;
    } else {
        return `${monthName} ${day}, ${year}`;
    }
}

function getRecipeField(recipe, field, lang = 'en') {
    if (typeof recipe[field] === 'object' && recipe[field] !== null) {
        return recipe[field][lang] || recipe[field]['en'] || Object.values(recipe[field])[0];
    }
    return recipe[field];
}

export {
    getUITranslation,
    getEnumTranslation,
    getRecipeTypeIcon,
    formatDate,
    getRecipeField
}; 